var _defs, _circle, _line, _line2, _circle2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew311({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.33,
    cy: 12.02,
    r: 1.84
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.33,
    y1: 2.14,
    x2: 5.33,
    y2: 10.92
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 3.19,
    y1: 4.42,
    x2: 7.47,
    y2: 4.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.67,
    cy: 12.02,
    r: 1.84
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 10.67,
    y1: 2.14,
    x2: 10.67,
    y2: 10.92
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.53,
    y1: 4.42,
    x2: 12.81,
    y2: 4.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew311);
export default __webpack_public_path__ + "static/media/Symbolpack_New_311.3823eae176e26eeb77dd7568e6d89df0.svg";
export { ForwardRef as ReactComponent };